import React from "react";
import { Input, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { updateResponseCommonComponent } from "../../redux/actions/commonComponentAction";
import { optionDetails } from "./optionDetails";
import { useMediaQuery } from "react-responsive";
const { TextArea } = Input;
const { Title } = Typography;

const TextInput = ({ value, onChange, placeholder, label, optionalText, rows }) => (
  <div>
    <h3>{label}</h3>
    {optionalText && <p style={{ fontSize: "14px", color: "gray" }}>{optionalText}</p>}
    <TextArea
      placeholder={placeholder}
      rows={rows}
      aria-label={label}
      style={{ height: "60px", resize: "none" }}
      value={value}
      onChange={onChange}
    />
  </div>
);


const CommonCom = ({ currentOption }) => {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const responses = useSelector((state) => state.commonComponent[currentOption]) || {};
  const selectedLanguage = useSelector((state) => state.language.selectedLanguage);

  const { heading, translations } = optionDetails[currentOption] || {};
  const translationsInSelectedLanguage = translations?.[selectedLanguage] || {};
  const translationsInEnglish = translations?.English || {};

  const { Question1 = "", Question2 = "", optionalText } = translationsInSelectedLanguage;
  const { Question1: EnglishQuestion1 = "", Question2: EnglishQuestion2 = "" } = translationsInEnglish;

  const handleChange = (questionKey, response) => {
    const questionTextInEnglish = questionKey === "question1" ? EnglishQuestion1 : EnglishQuestion2;
    dispatch(updateResponseCommonComponent(currentOption, questionKey, questionTextInEnglish, response));
  };

  if (!heading) {
    return <p>Option not available. Please select a valid option.</p>;
  }

  const renderQuestion = (questionKey, questionText, responseValue) => (
    <TextInput
      rows={3}
      label={questionText}
      placeholder="Enter your comments"
      value={responseValue}
      onChange={(e) => handleChange(questionKey, e.target.value)}
      optionalText={optionalText}
    />
  );

  return (
    <section style={isMobile ? {marginRight:'4%', marginLeft:'2%' }:{marginRight:'0%' }}>
      <Title level={4}>{heading}</Title>
      {Question1 && renderQuestion("question1", Question1, responses.question1?.response || "")}
      {Question2 && renderQuestion("question2", Question2, responses.question2?.response || "")}
    </section>
  );
};

export default CommonCom;
